import {
  useMutation,
  type UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

import { vestigasApi } from '~/services/kyClient';
import ToastService from '~/services/toast.service';

import { queryKeysDataSyncJob } from './queryKeys';
type DeleteJobParams = {
  jobId: string;
};

type SuccessResponse = {
  success: boolean;
};

/**
 * Deletes a data sync job.
 */
export const deleteDataSyncJob = async ({
  jobId,
}: DeleteJobParams): Promise<SuccessResponse> => {
  const response = await vestigasApi
    .delete(`data_sync/sync_job/${jobId}`)
    .json<SuccessResponse>();
  return response;
};

/**
 * React Query mutation hook for deleting a data sync job.
 * Automatically invalidates the jobs list query on success.
 *
 * @param options - Additional mutation options
 */
export const useMutationDeleteJob = (
  options?: Omit<
    UseMutationOptions<SuccessResponse, Error, DeleteJobParams>,
    'mutationFn'
  >,
) => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    ...options,
    mutationFn: deleteDataSyncJob,
    async onSuccess() {
      // Invalidate jobs list
      await queryClient.invalidateQueries({
        queryKey: queryKeysDataSyncJob.base(),
      });

      ToastService.success('Sync-Job erfolgreich gelöscht');
    },
  });

  return mutation;
};
